import { render, staticRenderFns } from "./UserActionDelete.vue?vue&type=template&id=46739836&"
import script from "./UserActionDelete.vue?vue&type=script&lang=ts&"
export * from "./UserActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports